// Owner's manual download configuration.
import manualAsset from "@/assets/owners-manual.pdf.asset.json";

export type OwnersManual = {
  url: string;
  title: string;
  subtitle: string;
  fileType: string;
  size: string;
};

export const OWNERS_MANUAL: OwnersManual | null = {
  url: manualAsset.url,
  title: "Owner's manual",
  subtitle: "6×16 Aluminum Binoculars — care, adjustment, and service",
  fileType: "PDF",
  size: "18.7 MB",
};
